import React, {Component, PropTypes} from 'react'
// API
import api from '../../apiClient/v2'
// CSS
import * as css from './ManagementOC.css'
// Const
import {NAME_REQUEST_BILLING} from '../constants/constants'
// Components 
import {PanelDataVendor, PanelDataRequest, PanelDataDocument} from './Panels.jsx'
import {TableServices} from './DataTable.jsx'
import {OptionRequestServices, OptionRequestOC} from './OptionRequest.jsx'
import {
    ModalTrigger,
    ModalAdminEmails
} from './Modales.jsx'

export class ManagementOC extends Component{
    constructor(props) {
        super(props)
        this.state = {
            servicesToBilling : [],
            billingRequest: {},
            statusAll: 0,
            totalNeto : 0,
            iva: 0,
            total: 0
        }
        this.getServicesForBilling = () => {
            const {idBillingRequest} = this.props
            api.billing().getServicesBillingFsb(idBillingRequest)
                .then(response => {
                    this.setState({
                        servicesToBilling: response.services,
                        statusAll : response.status_all,
                        totalNeto: response.total_neto,
                        iva: response.iva,
                        total: response.total
                    })
                    this.getBillingRequestData(response.services[0].billing_request_id)
                })
                .catch(err=>{})
        }
        this.getBillingRequestData = (idBillingRequest) => {
            api.billing().getBillingRequest(idBillingRequest)
                .then(response => {
                    this.setState({
                        billingRequest: response
                    })
                })
                .catch(err=>{})
        }
        this.statusPaymentService = (idService, evt) => {
            const statusClient = evt.target.checked
            api.billing().setStatusPaymentService(idService, statusClient)
                .then(response => {
                    this.getServicesForBilling()
                })
                .catch(err=>{})
        }
        this.statusPaymentAll = (evt) => {
            const statusClient = evt.target.checked
            const {idBillingRequest} = this.props
            api.billing().setStatusPaymentAllService(idBillingRequest, statusClient)
                .then(response => {
                    this.getServicesForBilling()
                })
                .catch(err=>{})
        }
        this.dischargeServices = () => {
            let request = api.billing().dischargeServices(this.state.billingRequest.idBillingRequest)
            request
                .then(response => {
                    this.getServicesForBilling()
                })
                .catch(err=>{})
            return request
        }
        this.dischargeOC = () => {
            let request= api.billing().dischargeOC(this.state.billingRequest.idBillingRequest)
            request
                .then(response => {
                    this.getServicesForBilling()
                })
                .catch(err=>{})
            return request
        }
        this.assignOC = (numberOC, file) => {
            let data = new FormData();
            data.append('pdfOC', file)
            data.append('numberOC', numberOC)
            let request = api.billing().assignOC(this.state.billingRequest.idBillingRequest, data)
            request    
                .then(response => {
                    this.getServicesForBilling()
                })
                .catch(err=>{})
            return request
        }
        this.rejectRequest = (msg) => {
            const {idBillingRequest} = this.props
            let request = api.billing().rejectRequest(idBillingRequest, msg)
            request    
                .then(response => {
                    this.getServicesForBilling()
                })
                .catch(err=>{})
            return request
        }
    }
    componentDidMount(){
       this.getServicesForBilling()
    }
    render(){
        const {idBillingRequest, idClient} = this.props
        return(
            <div className="container-fluid">
                <div className={`page-header row ${css.headerManagementOC}`}>
                    <div className="col-md-9">
                    <h3><span className='glyphicon glyphicon-info-sign'></span> Requerimiento orden de compra <small>
                        <label className="label label-info">{NAME_REQUEST_BILLING[this.state.billingRequest.status]}</label></small>
                    </h3>
                    </div>
                    <div className={`col-md-3 ${css.divExcelButton}`}>
                        <a className="btn btn-success btn-md pull-right"
                           href={`/api/billing/export/excel-oc-fsb?id_billing_request=${idBillingRequest}&billable=true&only_approve_client=true`}>
                            {'Exportar '}
                           <span className="glyphicon glyphicon-export"/>
                        </a>
                        <ButtonAdminEmails
                            idClient = {idClient}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3">
                        <PanelDataVendor
                        />
                    </div>
                    <div className="col-md-4">
                        <div className="panel panel-info">
                            <div className="panel-heading">Gestión Autorización Servicios</div>
                            <div className="panel-body">
                                <PanelDataRequest
                                />
                                <div className="btn-group">
                                    <OptionRequestServices
                                        status={this.state.billingRequest.status}
                                        dischargeServices={this.dischargeServices}
                                        rejectRequest={this.rejectRequest}
                                        data={{
                                            servicesApprove: this.state.servicesToBilling.filter(service => service.approve_client == 1),
                                            servicesNotApprove: this.state.servicesToBilling.filter(service => service.approve_client == 0),
                                            cantServices : this.state.servicesToBilling.length,
                                            totalNeto : this.state.totalNeto,
                                            iva : this.state.iva,
                                            total : this.state.total
                                        }}
                                        perms={this.props.perms}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-5">
                        <div className="panel panel-info">
                            <div className="panel-heading">Gestión Orden de Compra</div>
                            <div className="panel-body">
                                <PanelDataDocument
                                    status={this.state.billingRequest.status}
                                    creationDate={this.state.billingRequest.creation_date}
                                    lastUpdate={this.state.billingRequest.last_update}
                                />
                                <div className="btn-group">
                                    <OptionRequestOC
                                        status={this.state.billingRequest.status}
                                        dischargeOC={this.dischargeOC}
                                        assignOC={this.assignOC}
                                        data={{
                                            servicesApprove: this.state.servicesToBilling.filter(service => service.approve_client == 1),
                                            servicesNotApprove: this.state.servicesToBilling.filter(service => service.approve_client == 0),
                                            cantServices : this.state.servicesToBilling.length,
                                            totalNeto : this.state.totalNeto,
                                            iva : this.state.iva,
                                            total : this.state.total
                                        }}
                                        perms={this.props.perms}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="panel panel-primary">
                            <div className="panel-heading">Servicios realizados</div>
                                <TableServices
                                    services={this.state.servicesToBilling}
                                    statusAll={this.state.statusAll}
                                    totalNeto={this.state.totalNeto}
                                    iva={this.state.iva}
                                    total={this.state.total}
                                    statusPaymentService={this.statusPaymentService}
                                    statusPaymentAll={this.statusPaymentAll}
                                    canUpdateServices={this.state.billingRequest.status===1 && this.props.perms.approveServices}
                                />
                        </div>        
                    </div>    
                </div>    
            </div>
        )
    }
}
ManagementOC.propTypes = {
    idBillingRequest : PropTypes.number.isRequired,
    idClient : PropTypes.number.isRequired,
    perms: PropTypes.object.isRequired
}
const ButtonAdminEmails = ({idClient}) => {
    return (
        <ModalTrigger>
            {(isVisible, showModal, hideModal) =>
                <button
                    className="btn btn-md btn-info pull-right"
                    onClick={showModal}
                >
                    Destinatarios <span className="glyphicon glyphicon-list-alt"></span>
                    {isVisible &&
                    <ModalAdminEmails
                        hideModal={hideModal}
                        idClient={idClient}
                    />
                    }
                </button>
            }
        </ModalTrigger>
    )
}



// WEBPACK FOOTER //
// ./frontEnd/billing/management-oc/ManagementOC.jsx